import { useState } from 'react';
import { useListFetch } from '../../../../hooks';
import { notify } from '../../../../app';
import { getCallTaskDetailsById } from '../../../../api';
import { useRouteMatch } from 'react-router-dom';
import type { CallTaskDetail } from '../../../../api';

export type FormProps = {
  search: string | null;
  limit?: number;
  threshold?: number;
};

const defaultFormValues: FormProps = {
  search: '',
  limit: 3,
  threshold: 0,
};

export const useCallsManagement = (callTaskId: string = '') => {
  const [form, setForm] = useState<FormProps>(defaultFormValues);
  const [pageDetails, setPageDetails] = useState(1);

  const { params } = useRouteMatch<{ id: string }>();

  const {
    nodes: data,
    filters,
    setFilters,
    setSort,
    intializing: loadingChunks,
    refresh,
    ...rest
  } = useListFetch(
    () => {
      if (!callTaskId) return {};

      return getCallTaskDetailsById({});
    },
    {
      deps: [params?.id, callTaskId, pageDetails],
      resultKey: 'content',
      withQueryParams: true,
    }
  );

  return {
    setForm,
    form,
    data: data as CallTaskDetail[],
    filters,
    setFilters,
    setSort,
    pageDetails,
    setPageDetails,
    loadingChunks,
    ...rest,
  };
};
